import React, { Component } from "react";
import { Autocomplete, createFilterOptions, TextField } from "@mui/material";
import { getReferences } from "../../services/vu";
import {
  findCountriesByDescription,
  getCountryByCountryCodeOrDescription,
} from "../../helpers/form";
import AllowedCountry from "../../enums/AllowedCountry";
import CountryCode from "../../enums/Country";

export default class Country extends Component {
  constructor(props) {
    super(props);

    this.state = {
      countries: [],
      searchText: "",
      country: {},
    };
  }

  componentDidMount() {
    getReferences().then(({ soneCountryCodeList = [] }) => {
      const country = soneCountryCodeList.find((country) => {
        return country.countryCode === `${this.props.value}`;
      });

      this.setState({
        countries: soneCountryCodeList,
        searchText: country ? country.description : this.state.searchText,
      });
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.value !== this.props.value) {
      const country = this.getCountries().find((country) => {
        return country.countryCode === `${this.props.value}`;
      });

      this.setState({
        searchText: country ? country.description : this.state.searchText,
      });
    }
  }

  getCountries = () => {
    return this.state.countries.filter((country) => {
      switch (this.props.allowedCountries) {
        case AllowedCountry.Domestic:
          return country.countryCode === CountryCode.Australia;
        case AllowedCountry.International:
          return country.countryCode !== CountryCode.Australia;
        case AllowedCountry.Both:
        default:
          return true;
      }
    });
  };

  selectSuggestion = (event, inputText) => {
    this.setState({
      searchText: inputText,
    });
  };

  handleChange = (countryCode) => {
    this.props.onChange(this.props.name, countryCode);
  }

  getCountryBySearchText = (searchText) =>
    getCountryByCountryCodeOrDescription(searchText, this.getCountries());

  inputChange = (event, country) =>
    country
      ? this.handleChange(country.countryCode)
      : this.handleChange(null);

  handleClose = (event) => {
    if (this.state.searchText) {
      const country = this.getCountryBySearchText(this.state.searchText);
      if (country) {
        this.setState({
          searchText: country.description,
        });
      } else {
        const countries = findCountriesByDescription(
          this.state.searchText,
          this.getCountries(),
        );

        if (countries.length === 1) {
          this.setState({
            searchText: countries[0].description,
          });
          this.handleChange(countries[0].countryCode);
        }
      }
    }
  };

  render() {
    //const countries = this.getCountries();

    const filterOptions = createFilterOptions({
      matchFrom: "any",
      ignoreCase: true,
      stringify: (option) => option.description,
      limit: 5,
    });

    return this.state.countries.length && (
      <Autocomplete
        options={this.state.countries}
        filterOptions={filterOptions}
        getOptionLabel={(option) => option.description}
        isOptionEqualToValue={(option, value) =>
          option?.countryCode === value?.countryCode
        }
        disableClearable={true}
        onClose={this.handleClose}
        onInputChange={this.selectSuggestion}
        onChange={this.inputChange}
        inputValue={this.state.searchText}
        value={
          this.state.countries.find(
            (country) => country.countryCode === this.props.value,
          ) || null
        }
        renderInput={(params) => {
          params.InputProps.endAdornment = undefined;
          params.inputProps.readOnly =
            this.state.countries.length === 1 &&
            this.state.countries.some(
              (country) => country.countryCode === this.props.value,
            );
          return (
            <TextField
              {...params}
              error={!!this.props.errors}
              helperText={
                typeof this.props.errors === 'string'
                ? this.props.errors
                : this.props.errors
                  ? String(this.props.errors)
                  : ""
              }
              label="Country"
              variant="standard"
              fullWidth={true}
              margin="normal"
              sx={{ margin: 0 }}
            />
          );
        }}
      />
    );
  }
}
